/* eslint-disable */
import {DateUtils as StringUtils, DateUtils} from "@/utils/DateUtils";

export const SearchCriteria = {

    ARRAY_PREFIX: "array_",
    DATE_PREFIX: "date_",

    updateUrl(context) {
        const urlParam = {};
        Object.entries(context.searchCriteria).forEach(([key, value]) => {
            if (key !== "page") {
                if (value && Array.isArray(value)) {
                    urlParam[this.ARRAY_PREFIX + key] = "" + value;
                } else if (value && value.toISOString) {
                    urlParam[this.DATE_PREFIX + key] = value.toISOString();
                } else if (value || value === false) {
                    urlParam[key] = "" + value;
                }
            } else {
                Object.entries(value).forEach(([pageKey, pageValue]) => {
                    if (pageValue) {
                        urlParam["page" + pageKey] = "" + pageValue;
                    }
                });
            }
        });

        if (JSON.stringify(urlParam) !== JSON.stringify(context.$route.query)) {
            context.$router.push({name: context.$route.name, query: urlParam});
        }
    },

    loadCriteria(context) {
        Object.entries(context.$route.query).forEach(([key, value]) => {
            if (value) {
                if (key.startsWith("page")) {
                    context.searchCriteria.page[key.substr(4)] = isNaN(value) ? value : parseInt(value, 10);
                } else if (key.startsWith(this.ARRAY_PREFIX)) {
                    context.searchCriteria[key.replace(this.ARRAY_PREFIX, '')] = value.split(",");
                } else if (key.startsWith(this.DATE_PREFIX)) {
                    context.searchCriteria[key.replace(this.DATE_PREFIX, '')] = new Date(value);
                } else {
                    if (value === "false") {
                        context.searchCriteria[key] = false;
                    } else if (value === "true") {
                        context.searchCriteria[key] = true;
                    } else {
                        context.searchCriteria[key] = isNaN(value) ? value : parseInt(value, 10);
                    }
                }
            }
        });
    },

    prepareMinMaxDateCriteria(criteria, format) {
        let min = null;
        let max = null;
        if (criteria.value != null && criteria.value.length === 2) {
            if (criteria.value[0] != null) {
                min = DateUtils.formatDate(criteria.value[0], format);
            }
            if (criteria.value[1] != null) {
                max = DateUtils.formatDate(criteria.value[1], format);
            }
        }
        return {min: min, max: max};
    },

    prepareMinMaxDateCriteriaYearOnly(criteria, format) {
        let min = null;
        let max = null;

        if (criteria.value != null && criteria.value.length === 2) {
            if (criteria.value[0] != null && criteria.value[1] == null) {
                min = `${DateUtils.formatDate(criteria.value[0], format)}-01-01`;
                max = `${DateUtils.formatDate(criteria.value[0], format)}-12-31`;
            }
            if (criteria.value[0] != null && criteria.value[1] != null) {
                min = `${DateUtils.formatDate(criteria.value[0], format)}-01-01`;
                max = `${DateUtils.formatDate(criteria.value[1], format)}-12-31`;
            }
        }
        return {min: min, max: max};
    },

    prepareCriteria(criteria, filterDateByYear = false) {
        const result = {};
        for (const key in criteria) {
            if (criteria[key] && typeof criteria[key] === 'object' && 'value' in criteria[key]) {
                if (key === 'dateOfBirth' && filterDateByYear) {
                    result[key] = this.prepareMinMaxDateCriteriaYearOnly(criteria[key], StringUtils.defaultYearOnlyFormat);
                } else if (key === 'dateOfBirth') {
                    result[key] = this.prepareMinMaxDateCriteria(criteria[key], StringUtils.dateFormat);
                } else if (key === 'years') {
                    result[key] = this.prepareMinMaxDateCriteria(criteria[key], StringUtils.defaultYearOnlyFormat);
                } else {
                    result[key] = criteria[key].value;
                }
            }
        }
        result.page = criteria.page;
        return result;
    },

};
